<template>
    
    <div style="padding: 10px;">
        <el-dialog title="" :visible.sync="showTest" :close-on-click-modal=false width="70%" :before-close="handleDialogClose">
            <TestAndTaskDetail :testPaperId="testPaperId" v-if="showTest"  ></TestAndTaskDetail>
        </el-dialog>
        <el-table
            size="mini"
            :data="tableData"
        >
            <el-table-column
                prop="name"
                label="测试名称"
            >
            </el-table-column>
            <!-- <el-table-column
                prop="checkStatus"
                label="审核状态"                
            >
                <template slot-scope="scope">
                    <el-switch
                        v-if="scope.row.checkStatus == 1 || scope.row.checkStatus ==2 || scope.row.checkStatus ==''"
                        :width="50"
                        class="mr10 fl mt12"
                        v-model="scope.row.checkStatus"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        :active-value=2
                        :inactive-value=1
                        @change="checkPass(scope.row)"
                    >
                    </el-switch>
                    <el-switch
                        v-if="scope.row.checkStatus == 3 || scope.row.checkStatus ==4"
                        :width="50"
                        class="mr10 fl mt12"
                        v-model="scope.row.checkStatus"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        :active-value=4
                        :inactive-value=3
                        @change="checkPass(scope.row)"
                    >
                    </el-switch>
                    <el-button v-if="scope.row.checkStatus == 1" class="" type="text"  >
                        <el-tooltip class="item" effect="dark" :content="scope.row.checkResult | result" placement="top">
                            <span>原因</span>
                        </el-tooltip>
                    </el-button>
                </template>
            </el-table-column> -->
            <el-table-column
                prop="address"
                label="操作" width="180">
                <template slot-scope="scope">
                    <el-button @click="detail(scope.row)" type="text">查看详情</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>

  import https from '@/https.js';
  import {dateFormat_date} from '../../api/utils';
  import TestAndTaskDetail from './TestAndTaskDetail.vue';
  
  export default {
    name: '',
    props: ['courseId'],
    components: {
      TestAndTaskDetail: TestAndTaskDetail,
    },
    data() {
      return {
        tableData: [],
        showTest: false,
        testPaperId: "",
      };
    },

    methods: {
      handleClick(row) {

      },
      handleDialogClose() {
        this.showTest = false;
      },
      detail(row) {
        this.showTest = true;
        this.testPaperId = row.testPaperId;
      },
      testDate(row) {
        let startDate = dateFormat_date(row.startTime);
        let endDate = dateFormat_date(row.endTime);
        return startDate + ' - ' + endDate;
      },
      checkPass(row) {

        if (row.checkStatus == 1) {
          row.checkStatus = 3;
        }

        if (row.checkStatus == 2) {
          row.checkStatus = 4;
        }

        let params = { // 0 目录 1资源
          courseId: this.courseId,
          resourceId: row.resourcesId,
          resourceType: 1,
          checkStatus: row.checkStatus
        };
        https.fetchPost('/courseCheck/checkPass', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == '200') {
            this.$message({
              type: 'success',
              message: '操作成功'
            });
          } else {
            this.$message({
              type: 'info',
              message: '加载失败' + msg
            });
          }
        }).catch(err => {
              console.log(err);
            }
        );
      },
      search() {
        let params = {
          courseId: this.courseId,
          modelType: 4  //3 作业  4测试
        };
        https.fetchPost('/task/taskList', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == '200') {
            this.tableData = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败' + msg
            });
          }
        }).catch(err => {
              console.log(err);
            }
        );
      }
    },
    filters: {
      result(val) {
        return "试卷内容"+val;
      }
    },
    created: function() {
      this.search();
    }
  };
</script>

<style scoped>

</style>
